


export const PriceDataNorthAmerican = [
    {
        id: 1,
        species: 'Antelope',
        shoulder: 780,
        lifesize: 3200,
        extras: false
    },
    {
        id: 2,
        species: 'Badger',
        shoulder: 500,
        lifesize: 1075,
        extras: false
    },
    {
        id: 3,
        species: 'Bear (Black)',
        shoulder: 800,
        lifesize: 4000,
        extras: true
    },
    {
        id: 4,
        species:'Bear (Grizzley/Brown uner 6 feet)',
        shoulder: 800,
        lifesize: 4200,
        extras: true
    },
    {
        id: 5,
        species:'Bear (Grizzley/Brown over 6 feet)',
        shoulder: 900,
        lifesize: 4500,
        extras: true
    },
    {
        id: 6,
        species:'Beaver',
        shoulder: 'N/A' ,
        lifesize: 1150,
        extras: true
    },
    {
        id: 7,
        species:'Bison',
        shoulder: 1600,
        lifesize: 8900,
        extras: false
    },
    {
        id: 8,
        species:'Boar',
        shoulder: 850,
        lifesize: 3300,
        extras: true
    },
    {
        id: 9,
        species:'Bobcat',
        shoulder: 500,
        lifesize: 1275,
        extras: true
    },
    {
        id: 10,
        species:'Caribou',
        shoulder: 1250,
        lifesize: 5800,
        extras: false
    },
    {
        id: 11,
        species:'Coyote',
        shoulder: 475,
        lifesize: 1275,
        extras: true
    },
    {
        id: 12,
        species:'Deer (BlackTail)',
        shoulder: 775,
        lifesize: 3300,
        extras: false
    },
    {
        id: 13,
        species:'Deer (Coues)',
        shoulder: 750,
        lifesize: 3200,
        extras: false
    },
    {
        id: 14,
        species:'Deer (Mule)',
        shoulder: 800,
        lifesize: 3400,
        extras: false
    },
    {
        id: 15,
        species:'Deer (Whitetail)',
        shoulder: 800,
        lifesize: 3400,
        extras: false
    },
    {
        id: 16,
        species:'Elk',
        shoulder: 1350,
        lifesize: 5900,
        extras: true
    },
    {
        id: 17,
        species:'Lynx',
        shoulder: 600,
        lifesize: 1300,
        extras: true
    },
    {
        id: 18,
        species:'Moose (Shiras)',
        shoulder: 1600,
        lifesize: 9400,
        extras: false
    },
    {
        id: 19,
        species:'Moose (Alaskan)',
        shoulder: 1700,
        lifesize: 10400,
        extras: false
    },
    {
        id: 20,
        species:'Mountain Goat',
        shoulder: 1200,
        lifesize: 3650,
        extras: false
    },
    {
        id: 21,
        species:'Mountain Lion',
        shoulder: 950,
        lifesize: 4025,
        extras: true
    },
    {
        id: 22,
        species:'Sheep (Big Horn, Dall, Desert, Stone)',
        shoulder: 1250,
        lifesize: 4000,
        extras: false
    },
    {
        id: 23,
        species:'Wolverine',
        shoulder: 525,
        lifesize: 1250,
        extras: true
    }

]

export const PriceDataAfrican = [
    {
        id: 1 ,
        species:'Addax',
        shoulder: 1000,
        lifesize: 4600,
        extras: false
    },
    {
        id: 2,
        species:'Bush Buck',
        shoulder: 900,
        lifesize: 3500,
        extras: false
    },
    {
        id: 3,
        species:'Cape Buffalo',
        shoulder: 2250,
        lifesize: 12000,
        extras: false
    },
    {
        id: 4,
        species:'Ceracal Cat',
        shoulder: 475,
        lifesize: 1200,
        extras: true
    },
    {
        id: 5,
        species:'Civit Cat',
        shoulder: 475,
        lifesize: 1200,
        extras: true
    },
    {
        id: 6,
        species:'Dik (dik)',
        shoulder: 525,
        lifesize: 1400,
        extras: false
    },
    {
        id: 7,
        species:'Duiker',
        shoulder: 525,
        lifesize: 1400,
        extras: false
    },
    {
        id: 8,
        species:'Eland',
        shoulder: 2350,
        lifesize: 11050,
        extras: false
    },
    {
        id: 9,
        species:'Gazelle',
        shoulder: 825,
        lifesize: 3700,
        extras: false
    },
    {
        id: 10,
        species:'Giraffe',
        shoulder: 5425,
        lifesize: "N/A",
        extras: false
    },
    {
        id: 11,
        species:'Hartebeest',
        shoulder: 950,
        lifesize: 3600,
        extras: false
    },
    {
        id: 12,
        species:'Hyena',
        shoulder: 925,
        lifesize: 3350,
        extras: true
    },
    {
        id: 13,
        species:'Impala',
        shoulder: 800,
        lifesize: 3350,
        extras: false
    },
    {
        id: 14,
        species:'Jackal',
        shoulder: 550,
        lifesize: 1050,
        extras: true
    },
    {
        id: 15,
        species:'Kudu (Greater)',
        shoulder: 1550,
        lifesize: 5650,
        extras: false
    },
    {
        id: 16,
        species:'Kudu (Lesser)',
        shoulder: 950,
        lifesize: 3650,
        extras: false
    },
    {
        id: 17,
        species:'Leopard',
        shoulder: 1300,
        lifesize: 4500,
        extras: true
    },
    {
        id: 18,
        species:'Lion',
        shoulder: 1400,
        lifesize: 5600 ,
        extras: true
    },
    {
        id: 19,
        species:'Oryx',
        shoulder: 1200,
        lifesize: 4400,
        extras: false
    },
    {
        id: 20,
        species:'Reedbuck',
        shoulder: 875,
        lifesize: 3200,
        extras: false
    },
    {
        id: 21,
        species:'Serval Cat',
        shoulder: 550,
        lifesize: 1050,
        extras: true
    },
    {
        id: 22,
        species:'SpringBok',
        shoulder: 825,
        lifesize: 3200,
        extras: false
    },
    {
        id: 23,
        species:'Warthog',
        shoulder: 1000,
        lifesize: 3650,
        extras: true
    },
    {
        id: 24,
        species:'Wildebeest',
        shoulder: 1375,
        lifesize: 5100,
        extras: false
    },
    {
        id: 25,
        species:'Waterbuck',
        shoulder: 1475,
        lifesize: 4875,
        extras: false
    },
    {
        id: 26,
        species:'Zebra',
        shoulder: 1475,
        lifesize: 5075,
        extras: false
    },
    
]

 export const PriceDataNewZelandAndOthers = [
    {
        id: 1,
        species:'Aoudad',
        shoulder: 950,
        lifesize: 4100,
        extras: false
    },
    {
        id: 2,
        species:'Axis (Deer)',
        shoulder: 800,
        lifesize: 3500,
        extras: false
    },
    {
        id: 3,
        species:'BlackBuck',
        shoulder: 800,
        lifesize: 3400,
        extras: false
    },
    {
        id: 4,
        species:'Fallow (Deer)',
        shoulder: 800,
        lifesize: 3400,
        extras: false
    },
    {
        id: 5,
        species:'Ibex',
        shoulder: 850,
        lifesize: 4050,
        extras: false
    },
    {
        id: 6,
        species:'LongHorn',
        shoulder: 2350,
        lifesize: 15000,
        extras: false
    },
    {
        id: 7,
        species:'Mufalon/Corisican',
        shoulder: 825,
        lifesize: 4200,
        extras: false
    },
    {
        id: 8,
        species:'Sika (Deer)',
        shoulder: 800,
        lifesize: 3500,
        extras: false
    },
    {
        id: 9,
        species:'Stag',
        shoulder: 1350,
        lifesize: 5900,
        extras: false
    },
    {
        id: 10,
        species:'Tur',
        shoulder: 1000,
        lifesize: 5000,
        extras: false
    },
    {
        id: 11,
        species:'Thar',
        shoulder: 1100,
        lifesize: 4775,
        extras: false
    },
    

 ]